import PropTypes from 'prop-types';
import React from 'react';

import * as D from '../../../deps';
import BackstagePodcastDescription from '../../common/BackstagePodcastDescription';

const BackstagePodcastProgramDescription = props => {
  const descriptionContent = (
    <D.DescriptionBackstageWithLogger
      text={props.description}
      linkUrl={props.descriptionUrl}
      isExpanded={false}
      linkText={D.Constants.UserSettings.messages.readMore}
    />
  );

  return (
    <D.ContentSection isPodcastDescription={true}>
      <BackstagePodcastDescription descriptionContent={descriptionContent} />
    </D.ContentSection>
  );
};

BackstagePodcastProgramDescription.propTypes = {
  description: PropTypes.string,
  descriptionUrl: PropTypes.string,
};

export default BackstagePodcastProgramDescription;
